import { useEffect, useState } from 'react';
import ReactPageScroller from 'react-page-scroller';
import styled from 'styled-components';

import { DEVICE } from 'config/theme';
import Section from 'shared/components/Section';
import useMediaQuery from 'shared/hooks/useMediaQuery';

import BADGES from '../badgesData';

import Badges from './Badge';
import BadgesBar from './badgesBar';

type BadgeProps = {
  transitonStart: boolean;
  currentBg: string;
};

const BadgesSection = styled(Section)`
  margin: 0 auto;
  padding: 0 !important;
  height: calc(100vh - 8rem);
  overflow: hidden;
  position: relative;
  display: none;

  ${({ theme }) => theme.MEDIA.MD} {
    display: flex;
    flex-direction: column;
  }
`;

const BadgesWrapper = styled.div<BadgeProps>`
  background-color: ${({ currentBg }) => currentBg || 'white'};
  transition: background-color 1s ease;
  transition-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  height: 100%;
`;

function Desktop(): JSX.Element {
  const [sr, setSr] = useState(false);
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [blockScroll, setBlockScroll] = useState(false);
  const [transition, setTranstion] = useState(false);

  const { isMatch: isDesktop, mediaLoaded } = useMediaQuery(DEVICE.MD);

  useEffect(() => {
    if (sr) {
      document.body.style.overflowY = 'scroll';
    } else if (mediaLoaded && isDesktop) {
      document.body.style.overflowY = 'hidden';
    }

    return () => {
      document.body.style.overflowY = '';
    };
  }, [isDesktop, mediaLoaded, sr]);

  function handlePageChange(number: number): void {
    setCurrentPage(number);
    setSr(number === BADGES.length - 1);
  }

  useEffect(() => {
    if (blockScroll) {
      const timeout = setTimeout(() => {
        setBlockScroll(false);
        clearTimeout(timeout);
      }, 1000);
    }
  }, [blockScroll]);

  function scrollStart() {
    setTranstion(true);
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setTranstion(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [transition, currentPage]);

  return (
    <>
      <BadgesSection>
        <BadgesBar handleBadge={setCurrentPage} currentBadge={currentPage} />
        <BadgesWrapper transitonStart={transition} currentBg={BADGES[currentPage]?.background}>
          <ReactPageScroller
            // eslint-disable-next-line react/jsx-no-bind
            pageOnChange={handlePageChange}
            customPageNumber={currentPage}
            animationTimer={1000}
            blockScrollUp={blockScroll}
            blockScrollDown={blockScroll}
            onBeforePageScroll={() => {
              setBlockScroll(true);
              scrollStart();
            }}
          >
            {BADGES.map((badge, index) => (
              <Badges
                withHeader={index === 0}
                key={badge.id}
                badgeName={`${badge.name}`}
                urlName={`${badge.src}`}
                background={badge.background}
                onTransition={transition}
              />
            ))}
          </ReactPageScroller>
        </BadgesWrapper>
      </BadgesSection>
    </>
  );
}

export default Desktop;
